<template>
  <div class="product">
    <InfoPopup
      :v-if="product.info_popup"
      @open="open = true"
      @close="open = false"
      :open="open"
      v-bind="popupData"
    />

    <p class="name">{{ product.name }}</p>

    <InputAmount
      :model-value="productValue"
      @change="updateProductAmount($event)"
      @increase="updateProductAmount(productValue + 1)"
      @decrease="updateProductAmount(productValue - 1)"
    />
  </div>
</template>

<script>
import InfoPopup from '../popups/InfoPopup';
import InputAmount from '../utilities/InputAmount';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

export default {
  name: 'ProductRow',
  components: {
    InputAmount,
    InfoPopup,
  },
  data() {
    return {
      open: false,
    };
  },
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters({
      buildProducts: 'build/getProducts',
    }),
    productValue() {
      const buildProduct = this.buildProducts.find(
        (product) => product.id === this.product.id
      );

      return buildProduct ? buildProduct.amount : 0;
    },
    popupData() {
      return {
        ...this.product.info_popup,
        linkText: this.product.info_popup.link_text || '',
      };
    },
  },
  methods: {
    ...mapActions('build', ['updateProduct', 'resetLine']),
    ...mapMutations('filters', ['resetFilters']),
    updateProductAmount(amount) {
      this.resetFilters();
      this.resetLine();

      this.updateProduct({
        id: this.product.id,
        amount,
      });
    },
  },
};
</script>
